import React from 'react';
import BaseIcon from './BaseIcon';


// This icon only exists within the context of the Checkboxes component
const CheckMarkIcon = props => (
  <BaseIcon {...props}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-3.000000, -6.000000)" fillRule="nonzero">
        <path
          d="M11.0710678,12.0710678 L11.0710678,4.57106781 C11.0710678,3.74264069 11.7426407,3.07106781 12.5710678,3.07106781 C13.3994949,3.07106781 14.0710678,3.74264069 14.0710678,4.57106781 L14.0710678,13.5710678 C14.0710678,14.3994949 13.3994949,15.0710678 12.5710678,15.0710678 L7.57106781,15.0710678 C6.74264069,15.0710678 6.07106781,14.3994949 6.07106781,13.5710678 C6.07106781,12.7426407 6.74264069,12.0710678 7.57106781,12.0710678 L11.0710678,12.0710678 Z"
          transform="translate(10.071068, 9.071068) rotate(-315.000000) translate(-10.071068, -9.071068)"
        />
      </g>
    </g>
  </BaseIcon>
);

export default CheckMarkIcon;



// WEBPACK FOOTER //
// ./src-react/DesignSystem/Icons/CheckMarkIcon.jsx